<template lang="pug">
div(v-if="empleados")
	.row
		.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-3
			.card.mb-2(v-if="validacionesPendientes && permisos.gestion_jornada_aprobar_vacaciones")
				.alert.alert-warning.m-0
					| Hola {{usuario.nombre}}. Hay días pendientes de validar. Por favor atiéndelos cuanto antes para que se hagan efectivos.
				.card-footer
					.row
						.col.text-left
							button.btn.btn-block(:class="aprobando ? 'btn-success': ''" @click="toggleAccion('aprobar')")
								span.fa.fa-check.mr-2
								| Trabajar en ello
			.card
				table.table.table-striped.m-0
					thead.bg-dark.text-white
						tr
							th Empleado
							th Días
					tbody
						tr(
							v-for="usuario in empleados"
							:key="usuario.UsuarioID"
						)
							td {{usuario.UsuarioNombre}}
							td {{cuentaUsuario(usuario)}} / 23 días
		.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-9
			table.tabla.mb-3(
				v-for="mes in meses"
				:key="mes.mes"
			)
				thead.bg-dark.text-white
					tr
						th.text-left.pl-3 {{mes.mes}}
						th(
							v-for="dia in mes.dias"
							:key="mes.mes + '-' + dia.dia"
						) {{dia.dia}}
					tr(style="background-color:#888888 !important;")
						th.text-left.pl-3 Usuario/a
						th(
							v-for="dia in mes.dias"
							:key="mes.mes + '-' + dia.id"
						) {{dia.diaSem}}
				tbody
					tr(
						v-for="empleado in empleados"
						:key="empleado.UsuarioID"
					)
						td.text-left.pl-3 {{cuentaUsuario(empleado)}} / 23 - {{empleado.UsuarioNombre}}
						td(
							v-for="dia in mes.dias"
							:key="dia.id"
							:class="dia.festivo ? 'festivo' : diasJornada(dia, empleado) ? 'disabled' : claseDia(dia.id, empleado)"
							@click="toggleDia(dia, empleado)"
							:title="getTitulo(dia.id, empleado)"
						)
							span(:class="iconoDia(dia.id, empleado)")
	div(style="position:relative;display:inline-block;height: 100px;")
	div.aplicaCambios(:class="form.quitar.length > 0 || form.agregar.length > 0 ? 'activoCambios' : ''")
		div(style="position:relative;display:inline-block;vertical-align:middle;margin: 10px;")
			div(v-if="form.agregar.length > 0")
				span.mr-2 Añadir
				span(style="font-weight: bold;") {{ form.agregar.length }} días
			div(v-if="form.quitar.length > 0")
				span.mr-2 Quitar
				span(style="font-weight: bold;") {{ form.quitar.length }} días
		div(style="position:relative;display:inline-block;vertical-align:middle; margin: 10px;")
			button.btn.btn-large.btn-primary(@click="guardar()" :disabled="cargandoGuardar")
				span.fa.fa-check.mr-2(:class="cargandoGuardar ? 'fa-spinner fa-spin' : 'fa-check'")
				| {{ cargandoGuardar ? 'Enviando...' : 'Solicitar cambios'}}
	
	// Validación
	div.aplicaValidacion(:class="validacion.rechazar.length > 0 || validacion.aprobar.length > 0 ? 'activoCambios' : ''")
		div(style="position:relative;display:inline-block;vertical-align:middle;margin: 10px;")
			div(v-if="validacion.aprobar.length > 0")
				span.mr-2 Aprobar
				span(style="font-weight: bold;") {{ validacion.aprobar.length }} días
			div(v-if="validacion.rechazar.length > 0")
				span.mr-2 Rechazar
				span(style="font-weight: bold;") {{ validacion.rechazar.length }} días
		div(style="position:relative;display:inline-block;vertical-align:middle; margin: 10px;")
			button.btn.btn-large.btn-primary(@click="validar()")
				span.fa.fa-check.mr-2
				| Validar cambios
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
	props: ['ano', 'empleados', 'festivos'],
	data () {
		return {
			diaSem: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
			form: {
				quitar: [],
				agregar: []
			},
			validacion: {
				aprobar: [],
				rechazar: []
			},
			cargandoGuardar: false,
			aprobando: false,
			rechazando: false
		}
	},
	watch: {
		aprobando: function (newVal) {
			if (!newVal) {
				this.validacion.aprobar = []
				this.validacion.rechazar = []
			}
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		}),
		diasFestivos () {
			return this.festivos.reduce((acum, d) => {
				acum.push(d.dia)
				return acum
			}, [])
		},
		meses () {
			return new Array(12).fill(0).reduce((meses, i, mes) => {
				const fecha = new Date(this.ano, mes, 1, 12, 0, 0, 0)
				const mesActual = {
					mes: this.$moment(fecha).format('MMMM, YYYY'),
					dias: []
				}
				while (fecha.getMonth() === mes) {
					const diaStr = this.$moment(fecha).format('YYYY-MM-DD')
					mesActual.dias.push({
						dia: fecha.getDate(),
						diaSem: this.diaSem[fecha.getDay()],
						id: diaStr,
						// finde: /^(S|D)$/.test(this.diaSem[fecha.getDay()]),
						festivo: (this.diasFestivos.indexOf(diaStr) >= 0)
					})
					fecha.setTime(fecha.getTime() + 86400000)
				}
				meses.push(mesActual)
				return meses
			}, [])
		},
		validacionesPendientes () {
			return this.empleados.reduce((hay, empleado) => {
				for (let i = 0; i < empleado.dias.length; i++) {
					const dia = empleado.dias[i]
					if (dia.EstadoValidacion === 'Pendiente de aprobar' || dia.EstadoValidacion === 'Por quitar') {
						hay = true
					}
				}
				return hay
			}, false)
		}
	},
	methods: {
		cuentaUsuario (u) {
			if (u.UsuarioID !== this.usuario.ID) {
				return u.dias.length
			} else {
				return u.dias.length + this.form.agregar.length - this.form.quitar.length
			}
		},
		esVacaciones (dia, empleado) {
			return empleado.dias.reduce((acum, d) => {
				if (d.Dia === dia) {
					acum = true
				}
				return acum
			}, false)
		},
		claseDia (dia, empleado) {
			let clase = []
			if (empleado.UsuarioID === this.usuario.ID) {
				clase.push('usuario')
			}

			if (this.permisos.gestion_jornada_aprobar_vacaciones) {
				clase.push('validador')
			}

			if (this.aprobando || this.rechazando) {
				clase.push('validando')
			}
			return empleado.dias.reduce((acum, d) => {
				if (d.Dia === dia) {
					if (this.validacion.aprobar.indexOf(d.RegistroID) >= 0) {
						acum.push('aprobando')
					} else if (this.validacion.rechazar.indexOf(d.RegistroID) >= 0) {
						acum.push('rechazando')
					}
					if (d.EstadoValidacion === 'Pendiente de aprobar' || d.EstadoValidacion === 'Por quitar') {
						acum.push('pendiente')
					} else if (d.EstadoValidacion === 'Aprobado') {
						acum.push('aprobado')
					} else {
						acum.push('rechazado')
					}

					if (d.Bloqueado) {
						acum.push('bloqueado')
					}
				}
				return acum
			}, clase).join(' ')
		},
		iconoDia (dia, empleado) {
			if (this.form.quitar.indexOf(dia) >= 0 && empleado.UsuarioID === this.usuario.ID) {
				return 'fa fa-trash'
			} else if (this.form.agregar.indexOf(dia) >= 0 && empleado.UsuarioID === this.usuario.ID) {
				return 'fa fa-plus'
			}
			return empleado.dias.reduce((acum, d) => {
				if (d.Dia === dia) {
					if (d.EstadoValidacion === 'Pendiente de aprobar') {
						acum = 'fa fa-clock-o'
					} else if (d.EstadoValidacion === 'Aprobado') {
						acum = 'fa fa-check'
					} else {
						acum = 'fa fa-ban'
					}
				}
				return acum
			}, '')
		},
		getTitulo (dia, empleado) {
			return empleado.dias.reduce((acum, d) => {
				if (d.Dia === dia) {
					acum = d.EstadoValidacion
				}
				return acum
			}, '')
		},
		toggleAccion (accion) {
			if (accion === 'aprobar') {
				this.rechazando = false
				this.aprobando = !this.aprobando
			} else if (accion === 'rechazar') {
				this.aprobando = false
				this.rechazando = !this.rechazando
			}
		},
		toggleValidacion (infoDia, empleado) {
			if (!this.permisos.gestion_jornada_aprobar_vacaciones || (!this.aprobando && !this.rechazando)) {
				return false
			}

			for (let i = 0; i < empleado.dias.length; i++) {
				const d = empleado.dias[i]
				if ((d.EstadoValidacion === 'Pendiente de aprobar' || d.EstadoValidacion === 'Por quitar') && infoDia.id === d.Dia) {
					const idx = this.validacion.aprobar.indexOf(d.RegistroID)
					const idxR = this.validacion.rechazar.indexOf(d.RegistroID)

					if (idx < 0 && idxR < 0) {
						this.validacion.aprobar.push(d.RegistroID)
					} else if (idx >= 0) {
						this.validacion.aprobar.splice(idx, 1)
						this.validacion.rechazar.push(d.RegistroID)
					} else if (idxR >= 0) {
						this.validacion.rechazar.splice(idxR, 1)
					}
				}
			}
			return true
		},
		diasJornada (dia, empleado) {
			return !empleado.jornada.includes(dia.diaSem)
		},
		toggleDia (infoDia, empleado) {
			const dia = infoDia.id
			if (this.diasJornada(infoDia, empleado) || infoDia.festivo) {
				return
			}
			if (this.toggleValidacion(infoDia, empleado)) {
				return false
			}
			if (empleado.UsuarioID !== this.usuario.ID) {
				return
			}
			const idE = this.form.quitar.indexOf(dia)
			const idA = this.form.agregar.indexOf(dia)

			if (idE >= 0) {
				if (this.form.agregar.length + 1 - this.form.quitar.length + empleado.dias.length > 23) {
					this.$error('Error', 'El límite de días de vacaciones al año es de 23 días laborables')
					return
				}
				this.form.quitar.splice(idE, 1)
			} else if (idA >= 0) {
				this.form.agregar.splice(idA, 1)
			} else {
				let bloqueado = false
				const seleccionado = empleado.dias.reduce((acum, d) => {
					if (d.Dia === dia) {
						acum = true
						if (d.Bloqueado) {
							bloqueado = true
						}
					}
					return acum
				}, false)

				if (bloqueado) {
					return
				}

				if (seleccionado) {
					this.form.quitar.push(dia)
				} else {
					this.form.agregar.push(dia)
					if (this.form.agregar.length - this.form.quitar.length + empleado.dias.length > 23) {
						this.$error('Error', 'El límite de días de vacaciones al año es de 23 días laborables')
						this.form.agregar.splice(-1, 1)
					}
				}
			}
		},
		guardar () {
		    if (this.cargandoGuardar) return
		    this.cargandoGuardar = true
		    axios.post('gestion-jornada/php/api/vacaciones/set.php', this.form)
		        .then(res => {
		            this.$store.commit('toast/success', {
		                titulo: 'Vacaciones solicitadas'
		            })
		            this.form.agregar = []
		            this.form.quitar = []
		            this.$emit('buscar')
		        })
		        .catch(this.$responseError)
		        .finally(() => {
		            setTimeout(() => {
		                this.cargandoGuardar = false
		            }, 2000)
		        })
		},
		validar () {
			axios.post('gestion-jornada/php/api/vacaciones/validar.php', this.validacion)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Modificaciones guardadas',
						mensaje: 'Se notificará a los empleados implicados los cambios'
					})
					this.validacion.aprobar = []
					this.validacion.rechazar = []
					this.aprobando = false
					this.$emit('buscar')
				})
				.catch(this.$responseError)
		}
	}
}
</script>

<style scoped>
.tabla {
	width: 100%;
	background-color: white;
}
.tabla > thead {
	background-color: #333333;
	color: white;
}

.tabla > thead > tr > th {
	padding: 1px;
	border: 1px solid #f0f0f0;
	min-width: 15px;
	max-width: 15px;
	text-align: center;
}

.tabla > tbody > tr:nth-child(even) {
	background-color: #f0f0f0;
}

.tabla > tbody > tr > td {
	border: 1px solid #e0e0e0;
	min-height: 15px;
	max-height: 15px;
	text-align: center;
}

td.usuario {
	cursor: pointer;
}

td.usuario:hover {
	background-color: #858ad6;
	color: white;
}

td.disabled {
	background-color: #CCCCCC !important;
}

td.festivo {
	background-color: #9dff00;
}

td.bloqueado {
	cursor: not-allowed;
}

td.bloqueado:hover {
	background-color: inherit;
	color: inherit;
}

td.pendiente {
	background-color: #fdff96 !important;
	color: black;
}

td.validador.pendiente {
	cursor: pointer;
}

td.aprobado {
	background-color: #b3ffc3 !important;
	color: black !important;
}

td.rechazado {
	background-color: #ffa5a3 !important;
	color: black !important;
}

td.aprobando {
	background-color: green !important;
	opacity: 1 !important;
	color: white;
}

td.validando {
	opacity: 0.3;
	cursor: default;
}

td.validando:hover {
	background-color: inherit;
}

td.rechazando {
	background-color: red !important;
	opacity: 1 !important;
	color: white;
}

td.eliminado {
	background-color: #ff6e6b !important;
	color: darkblue !important;
}

.aplicaCambios {
	position: fixed;
	display: block;
	text-align: right;
	right: 0;
	bottom: -90px;
	left: 0;
	height: 80px;
	padding-right: 40px;
	padding-top: 20px;
	background-color: #38394d;
	color: white;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
	transition: transform 0.2s ease-in-out;
}
.aplicaValidacion {
	position: fixed;
	display: block;
	text-align: right;
	right: 0;
	bottom: -90px;
	left: 0;
	height: 80px;
	padding-right: 40px;
	padding-top: 20px;
	background-color: #85666a;
	color: white;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
	transition: transform 0.2s ease-in-out;
}

.activoCambios {
	transform: translateY(-90px) !important;
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/vacaciones/resultados.vue